import React from "react";
import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import styles from "./CtaButton.module.css";

const CtaButton = ({
  to,
  href,
  scrollTo,
  onClick,
  children,
  variant = "primary"
}) => {
  const className = `${styles.ctaButton} ${styles[variant]}`;

  if (scrollTo) {
    return (
      <ScrollLink
        to={scrollTo}
        spy={true}
        smooth={"easeInOutQuad"}
        offset={-76}
        duration={500}
        className={className}
      >
        {children}
      </ScrollLink>
    );
  }

  if (to) {
    return (
      <RouterLink to={to} className={className}>
        {children}
      </RouterLink>
    );
  }

  if (href) {
    return (
      <a
        href={href}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  }

  return (
    <button onClick={onClick} className={className}>
      {children}
    </button>
  );
};

CtaButton.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
  scrollTo: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["primary", "secondary"])
};

export default CtaButton;

